import { FetchStatusError } from '@/app/components/hotel-detail/common/fetchWithTracing';
import { clientAppLogError } from '@/app/components/search/logging/clientAppLog.ts';
import { isNetworkFailure } from '@/utils/errors.ts';

// fetchWithTracing already logged a non-2xx answer, but not a dropped connection or an unreadable body.
export const logChangeTransportFailure = (error: unknown) => {
  if (error instanceof FetchStatusError) return;
  // A dropped connection is the network's fault; anything else, like a body that is not JSON, is our bug.
  const level = isNetworkFailure(String((error as Error | undefined)?.message)) ? 'WARN' : 'ERROR';
  clientAppLogError({ level, codeSourceName: 'ChangeTransport:onChangeTransport', error });
};
